import { Mark, mergeAttributes } from "@tiptap/core";

const ImageLink = Mark.create({
    name: "imageLink",
    inclusive: false,

    addAttributes() {
        return {
            imageId: { default: null },
            url: { default: null },
            label: { default: null },
            description: { default: null },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'span[data-image-link]',
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            "span",
            mergeAttributes(HTMLAttributes, {
                "data-image-link": "",
                style: "color: #d56d10; text-decoration: underline; cursor: pointer; font-weight: 500;",
                class: "fw-bold"
            }),
            0,
        ];
    },

    addCommands() {
        return {
            setImageLink:
                (attrs) =>
                    ({ commands }) => {
                        return commands.setMark(this.name, attrs);
                    },

            unsetImageLink:
                () =>
                    ({ commands }) => {
                        return commands.unsetMark(this.name);
                    },
        };
    },
});

export default ImageLink;
